import { useMutation } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { UpdatePasswordRequest } from "services/management-backend/client";

const useUpdatePassword = () => {
  const clients = useClientContext();
  return useMutation({
    mutationFn: (req: UpdatePasswordRequest) =>
      clients.management.replacePassword(req),
  });
};

export default useUpdatePassword;
